// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ===== HERO CARD – IMAGE MATCH ===== */
.section-home-banner {
  /* Welcome text */
  /* NO. 1 */
  /* Subtitle */
}
.section-home-banner .slider-text-box {
  color: #111 !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 15px;
}
.section-home-banner .header-welcome {
  font-size: 16px !important;
  font-weight: 500;
  margin-bottom: 15px;
}
.section-home-banner .header-welcome .header-welcome-text {
  font-size: 18px !important;
  font-weight: 500;
  line-height: 1.4;
}
.section-home-banner .header-welcome .header-welcome-icon img {
  height: 42px;
}
.section-home-banner .hero-title {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin: 10px 0 8px;
}
.section-home-banner .no-text {
  font-size: 50px;
  font-weight: 700;
  color: #fff;
}
.section-home-banner .no-number {
  font-family: "Georgia", "Times New Roman", serif;
  font-size: 100px;
  font-weight: 800;
  line-height: 1;
  color: #fff;
}
.section-home-banner .hero-subtitle {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 5px;
  min-height: 95px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,wCAAA;AACA;EAUI,iBAAA;EAiBA,UAAA;EAsBA,aAAA;AA5CJ;AAHI;EACI,sBAAA;EACA,qDAAA;EACA,gCAAA;EACA,wCAAA;EACA,mBAAA;AAKR;AADI;EACI,0BAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AADQ;EACI,0BAAA;EACA,gBAAA;EACA,gBAAA;AAGZ;AAAQ;EACI,YAAA;AAEZ;AAGI;EACI,aAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AADR;AAII;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAKI;EACI,gDAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAHR;AAOI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AALR","sourcesContent":["/* ===== HERO CARD – IMAGE MATCH ===== */\r\n.section-home-banner {\r\n\r\n    .slider-text-box {\r\n        color: #111 !important;\r\n        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;\r\n        backdrop-filter: none !important;\r\n        -webkit-backdrop-filter: none !important;\r\n        border-radius: 15px;\r\n    }\r\n\r\n    /* Welcome text */\r\n    .header-welcome {\r\n        font-size: 16px !important;\r\n        font-weight: 500;\r\n        margin-bottom: 15px;\r\n\r\n        .header-welcome-text {\r\n            font-size: 18px !important;\r\n            font-weight: 500;\r\n            line-height: 1.4;\r\n        }\r\n\r\n        .header-welcome-icon img {\r\n            height: 42px;\r\n        }\r\n    }\r\n\r\n    /* NO. 1 */\r\n    .hero-title {\r\n        display: flex;\r\n        align-items: baseline;\r\n        gap: 12px;\r\n        margin: 10px 0 8px;\r\n    }\r\n\r\n    .no-text {\r\n        font-size: 50px;\r\n        font-weight: 700;\r\n        color: #fff;\r\n    }\r\n\r\n    .no-number {\r\n        font-family: \"Georgia\", \"Times New Roman\", serif;\r\n        font-size: 100px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n        color: #fff;\r\n    }\r\n\r\n    /* Subtitle */\r\n    .hero-subtitle {\r\n        font-size: 36px;\r\n        font-weight: 700;\r\n        line-height: 1.25;\r\n        margin-top: 5px;\r\n        min-height: 95px;\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
